module.exports = __webpack_public_path__ + "img/Technologies.ee147b15.png";